import { createRouter, createWebHistory } from 'vue-router'

import ArmoryView from '@/views/armory/ArmoryView.vue'
import BuildingsView from '@/views/building/BuildingsView.vue'
import BuildingsSettingsView from '@/views/building/BuildingsSettingsView.vue'
import BuildingsShowView from '@/views/building/BuildingsShowView.vue'
import DashboardLayout from '@/layaouts/DashboardLayout.vue'
import DashboardView from '@/views/DashboardView.vue'
import LoginView from '@/views/login-signup/LoginView.vue'
import ResearchView from '@/views/research/ResearchView.vue'
import SignupView from '@/views/login-signup/SignupView.vue'

const routes = [
    { path: "/", name: "login", component: LoginView },

    { path: "/signup", name: "signup", component: SignupView },
    {
        path: "/dashboard",
        component: DashboardLayout,
        children: [
            { path: "", name: "dashboard", component: DashboardView },
            { path: "facilities", name: "facilities", component: BuildingsView },
            { path: "facilities/buildings", name: "facilitiesBuildings", component: BuildingsShowView },
            { path: "facilities/settings", name: "facilitiesSettings", component: BuildingsSettingsView },
            { path: "research", name: "research", component: ResearchView },
            { path: "armory", name: "Armory", component: ArmoryView }
        ],
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

export default router;